import type { EventExtraChoiceItem } from '@cocoonspace/sdk-js/types/eventExtraChoiceItem'
import { Card } from '@cocoonspace/ui/components/card'
import { cn } from '@cocoonspace/ui/lib/utils'
import { useLingui } from '@lingui/react/macro'

import { QuantityInput } from '~/components/atoms/quantity-input'

export const ExtraMenuPicker = ({
	readOnly,
	menu,
	min,
	max,
	onQtyChange,
	className,
}: {
	menu: EventExtraChoiceItem
	readOnly?: boolean
	min?: number
	max: number
	className?: string
	onQtyChange: (qty: number) => void
}) => {
	const { t } = useLingui()

	return (
		<Card
			className={cn(
				'flex flex-row items-center justify-between px-4 py-2',
				className,
			)}
		>
			<div className='text-sm'>
				{menu.id === 'fish' && t`🐟 Poisson`}
				{menu.id === 'meat' && t`🍗 Viande`}
				{menu.id === 'veggie' && t`🥗 Végétarien`}
			</div>

			<QuantityInput
				buttonsClassName='size-[30px]'
				max={max}
				min={min || 0}
				onQtyChange={onQtyChange}
				readOnly={readOnly}
				value={menu.quantity}
			/>
		</Card>
	)
}
